const getters = {
  viewLayout (state, getters, rootState, rootGetters): string {
    const userRole = rootGetters['auth/userRole']

    return userRole === 'platform'
      ? 'LayoutInsights'
      : 'LayoutDefault'
  },

  isAppliedPageFilter (state) {
    return (filters = [], values = []) => {
      const appliedFilters = filters.filter(filter => state.pageFilter[filter].length > 0)

      if (appliedFilters.length && values.length) {
        return appliedFilters.some(filter => {
          return values.some(value => state.pageFilter[filter].includes(value))
        })
      }

      return Boolean(appliedFilters.length)
    }
  }
}

export default getters
